import React from 'react';
import { CoffeeIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { TrustRow } from './TrustRow';
import { Countdown } from '../hooks/useCountdown';
type UrgencySectionProps = {
  checkoutUrl: string;
  countdown: Countdown;
  claimed: number;
  total: number;
};
export function UrgencySection({
  checkoutUrl,
  countdown,
  claimed,
  total
}: UrgencySectionProps) {
  const percent = Math.min(100, Math.round(claimed / total * 100));
  return <section className="border-b border-white/5 bg-ink-900 py-16 sm:py-20" aria-labelledby="urgencia-title" data-id="element-133" data-mp="3b89284o56cyr">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-134" data-mp="3p8a3vmc8dofa">
        <p className="inline-flex items-center gap-1.5 rounded-full bg-flame px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-135" data-mp="3l6owuhmdo4d0">
          <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-136" data-mp="1uv2h8hyesj4q" />
          Solo por hoy
        </p>

        <h2 id="urgencia-title" className="mx-auto mt-5 max-w-2xl font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-5xl" data-id="element-137" data-mp="1qv0b9wln53jn">
          Acceso total por el precio de un café{' '}
          <span className="text-flame" data-id="element-138" data-mp="32rc5gmpe2gy7">($7 USD)</span>
        </h2>

        <p className="mx-auto mt-4 flex max-w-xl items-center justify-center gap-2 text-lg text-white/60" data-id="element-139" data-mp="32prdn4uglc41">
          <CoffeeIcon className="h-5 w-5 shrink-0 text-white/40" aria-hidden="true" data-id="element-140" data-mp="37kdkcuplighs" />
          Un latte se te acaba en 10 minutos. Esto te cambia los próximos 30 días.
        </p>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-white/10 bg-ink-850 p-6 sm:p-8" data-id="element-141" data-mp="3glbttsiszg7r">
          <div className="flex flex-col items-center gap-8 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="3lg93n1nwptlp">
            <CountdownTimer countdown={countdown} label="La oferta se cierra en:" size="lg" className="text-left" data-id="element-143" data-mp="3qf2eembt76i6" />
            <div className="w-full text-left sm:max-w-[15rem]" data-id="element-144" data-mp="1w5hxwmkpjaqo">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-145" data-mp="1o3r2o8jdhwd2">Cupos con descuento</p>
              <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-ink-700" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={claimed} aria-label="Cupos reclamados" data-id="element-146" data-mp="1k2p3tstdbmbm">
                <div className="h-full rounded-full bg-flame transition-[width] duration-300 ease-smooth" style={{
                width: `${percent}%`
              }} data-id="element-147" data-mp="26zh7e3iox6un" />
              </div>
              <p className="mt-2 text-sm text-white/60" data-id="element-148" data-mp="2gt7tx2v9b77p">
                <strong className="font-bold text-white" data-id="element-149" data-mp="2btlgasbinoyd">{total - claimed}</strong> de {total} copias disponibles a este
                precio
              </p>
            </div>
          </div>

          <div className="mt-8" data-id="element-150" data-mp="2lrj1t81zr7na">
            <CtaButton href={checkoutUrl} className="w-full" data-id="element-151" data-mp="2lodd3tx9y7s3">
              Sí, dame mi guía por $7
            </CtaButton>
            <TrustRow className="mt-4" align="center" data-id="element-152" data-mp="39dv0rq5ewgk3" />
          </div>
        </div>

        <p className="mt-6 text-sm text-white/40" data-id="element-153" data-mp="39biontmc50ey">
          Cuando el reloj llegue a cero el precio vuelve a $27. Sin excepciones.
        </p>
      </div>
    </section>;
}